import React, { Component } from "react";
import { Table, Badge, Container } from "react-bootstrap";
import { numberWithCommas } from "../../../../helpers/dataHelpers";
import { gold_medal, silver_medal, bronze_medal } from "../../../../images";
import { connect } from "react-redux";

import {
  GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4,
} from "../../../../store/actions/reports-v4/previous_month_average_service_actions";

import {
  GetMasterClusters,
  GetMasterAreas,
  GetPeppHierarchy,
} from "../../../../store/actions/crdm_service_actions";
import { RankingContext } from "./ranking_context";

import ranked from "ranked";
import { ToggleButtonGroup } from "react-bootstrap";
import { ToggleButton } from "react-bootstrap";
import { CenteredSpinner } from "../../../../components/extensions";

class ClusterRanking extends Component {
  state = {
    filterBy: "piece",
    clusters: [],
  };

  appendItemData = () => {
    let { master_cluster, pma_month, pma_year } = this.props;
    this.premiseGetMasterClusters().then((dd) => {
      this.premiseGetPeppHeirarchy({
        isSpecial: this.props.isSpecial,
        cluster_ids: master_cluster.map((d) => d.id),
      }).then((pepp) => {
        this.premiseGetPreviousMonthAverageCluster({
          month: pma_month,
          year: pma_year,
          cluster_ids: master_cluster.map((d) => d.id),
        });
      });
    });
  };

  getAreasByClusterId = (context, data) => {
    let { pepp_hierarchy } = this.props;

    if (pepp_hierarchy != null) {
      let areas = pepp_hierarchy
        .filter((cl) => cl.clusterId === data.id)
        .map((cluster) =>
          cluster.branchesByArea.map((areas) => {
            return areas.areaCode;
          })
        );

      context.gotoAreaView({
        cluster: data,
        areas: areas[0],
      });
    }
  };

  _bindSummaries = (clusterList) => {
    const rankFn = (item) =>
      this.state.filterBy === "piece"
        ? item.averagePieces
        : item.averagePrincipal;

    let itemRank = ranked.ranking(clusterList, rankFn, {
      strategy: "ordinal",
    });

    return itemRank.map((rItem) => {
      return {
        id: rItem.item.clusterId,
        rank: rItem.rank,
        name: `${rItem.item.clusterName}`,
        code: rItem.item.clusterCode,
        totalPieces: rItem.item.averagePieces,
        totalAmount: rItem.item.averagePrincipal,
      };
    });
  };

  handleSelectedFilterBy = (val) => {
    this.setState({ filterBy: val });
    this.appendItemData();
  };

  renderTable = (context) => {
    return (
      <Table
        className="mt-3"
        hover
        responsive
        size="sm"
        variant="light"
        striped
      >
        <caption className="small">
          <span className="m-3">Ranked by</span>
          <ToggleButtonGroup
            onChange={this.handleSelectedFilterBy}
            size="sm"
            name="filterByRadio"
            type="radio"
            value={this.state.filterBy}
          >
            <ToggleButton variant="light" value="piece">
              Piece
            </ToggleButton>
            <ToggleButton variant="light" value="principal">
              Principal
            </ToggleButton>
          </ToggleButtonGroup>
        </caption>

        <thead>
          <tr>
            {context.state.cluster_headers.map((data) => {
              return <th key={data.id}>{data.name}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {this._bindSummaries(this.props.clusterSummaries).map((data) => {
            return (
              <tr key={data.id}>
                <td>
                  <div>
                    <div style={{ display: "inline" }} className="mr-2">
                      {data.rank}
                    </div>
                    <img
                      alt="gold"
                      hidden={data.rank !== 1}
                      height="21"
                      src={gold_medal}
                    />
                    <img
                      alt="silver"
                      hidden={data.rank !== 2}
                      height="21"
                      src={silver_medal}
                    />
                    <img
                      alt="bronze"
                      hidden={data.rank !== 3}
                      height="21"
                      src={bronze_medal}
                    />
                  </div>
                </td>
                <td>
                  <span>
                    <span
                      className="btn-link"
                      onClick={() => {
                        this.getAreasByClusterId(context, data);
                      }}
                    >
                      {data.name}
                    </span>
                    <span className="ml-1">
                      <Badge variant="secondary">{data.code}</Badge>
                    </span>
                  </span>
                </td>
                <td>
                  <div
                    style={{
                      display: "inline",
                      color: "#2f3542",
                      fontWeight: "bold",
                    }}
                  >
                    {numberWithCommas(data.totalPieces)}
                  </div>
                  {`/${numberWithCommas(
                    Math.round(data.totalAmount / 50) * 50
                  )}`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  };

  render() {
    return (
      <RankingContext.Consumer>
        {(context) =>
          context.isLoading ? (
            <CenteredSpinner />
          ) : (
            <Container>{this.renderTable(context)}</Container>
          )
        }
      </RankingContext.Consumer>
    );
  }

  premiseGetPeppHeirarchy = (data) => {
    return this.props.GetPeppHierarchy(data);
  };

  premiseGetPreviousMonthAverageCluster = (data) => {
    return this.props.GetPreviousMonthAverageClusterV4(data);
  };

  premiseGetPreviousMonthAverageArea = (data) => {
    return this.props.GetPreviousMonthAverageAreaV4(data);
  };

  premiseGetMasterClusters = () => {
    return this.props.GetMasterClusters();
  };

  premiseGetMasterAreas = () => {
    return this.props.GetMasterAreas();
  };
}

const mapStateToProps = (state) => {
  return {
    clusterSummaries: state.previous_month_average.clusterSummaries,
    pma_month: state.previous_month_average.pma_month,
    pma_year: state.previous_month_average.pma_year,

    isSpecial: state.crdm.isSpecial,

    areaSummaries: state.previous_month_average.areaSummaries,
    master_cluster: state.crdm.master_cluster,
    pepp_hierarchy: state.crdm.pepp_hierarchy,
  };
};

const mapDispatchToProps = {
  GetPreviousMonthAverageAreaV4: GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4: GetPreviousMonthAverageClusterV4,
  GetMasterClusters: GetMasterClusters,
  GetMasterAreas: GetMasterAreas,
  GetPeppHierarchy: GetPeppHierarchy,
};

ClusterRanking.contextType = RankingContext;

export default connect(mapStateToProps, mapDispatchToProps)(ClusterRanking);
